export const getters = (state) => ({
  getNutzungsgradData(type) {
    const { topFlopNutzungsgradTable } = state.centralHeatings.dashboard;
    return topFlopNutzungsgradTable[type];
  },
});
